<div class="carousel d-flex" *ngIf="!panels || !panels.length">
    <div class="content text-color-white d-flex fd-col justify-content-center align-items-center">
        <sit-icon [icon]="Icon.no_panel" sizeClass="icon-size-800" class="centered"></sit-icon>
        <span>Problemas de conexión</span>
    </div>
</div>
<div class="carousel d-flex" *ngIf="panels && panels.length">
    <button (click)="prev()" [disabled]="!panels || index === 0"> <sit-icon [icon]="Icon.backward"></sit-icon> </button>
    <img class="content" *ngIf="panels[index]" [src]="getImageB64(panels[index])" alt="panel">
    <button (click)="next()" [disabled]="!panels || index === panels.length - 1"> <sit-icon
            [icon]="Icon.forward"></sit-icon> </button>
</div>